module.exports = __webpack_public_path__ + "img/html_item.e4ebfc09.svg";